import React, { useState, useEffect } from "react";
import Style from "./index.module.css";
import { Carousel } from "antd";
import { getMapStatics,getTotalNum } from "../../api/map"
import LoadingEmpty from "../loadingOrEmpty/index"
const DataTotal = () => {
  const [totalNum, setTotalNum] = useState(0);
  const [listData, setListData] = useState([]);
  const [listNum, setListNum] = useState([]);
  const [loading,setLoading]=useState(true)
  const date = new Date();
const year = date.getFullYear(); 
const month = date.getMonth() + 1; 
const day = date.getDate()

  useEffect(() => {
    setLoading(true)
    getTotalNum({}).then((res) => {
      setTotalNum(res.result);
    });
    
    getMapStatics({
      type:2
    }).then((res) => {
      setListData(res.result);
      setLoading(false)
    });
    
    getMapStatics({
      type:3
    }).then((res) => {
      setListNum(res.result);
    });
     
  }, []);

  return (
    <div className={Style.wrapCount}>
      <div className={Style.title}>
        <h1>贵州省民间文艺版权登记作品</h1>
        <div className={Style.totalNum}>
          总计：<span>{totalNum}</span>  件
        </div>
      </div>
     
      {/* <Carousel dots={false} autoplay> */}
        <div className={Style.title}>
        <h2>各类别登记作品数</h2>
         <LoadingEmpty
            loading={loading}
            empty={listData.length===0?true:false}
          />
          <div className={Style.listWrap}>
            {listData.map((item, index) => {
              return (
                <div key={index} className={Style.list}>
                  <div style={{fontSize:'20px'}}>{item.count}</div>
                  <div style={{fontSize:'20px'}}>{item.name}</div>
                </div>
              );
            })}
          </div>
        </div>
        {/* <div className={Style.title}>
          <h2>各地区著作权人数</h2>
          <div className={Style.listWrap}>
            {listNum.map((item, index) => {
              return (
                <div key={index} className={Style.list1}>
                  <div>{item.count}</div>
                  <div style={{padding:5}}>{item.name}</div>
                </div>
              );
            })}
          </div>
        </div>     */}
      {/* </Carousel> */}
      <div className={Style.bottom}>说明：数据统计截至{year}年{month}月{day}日。</div>
    </div>
  );
};

export default DataTotal;
